/**
 * 开发认证旁路（VITE_DEV_AUTH_BYPASS=1）下：用户点击「退出」时写入 sessionStorage，
 * 避免 FeishuAuthProvider / useApiInit 再次自动写入 dev-bypass-token，从而能显示登录页。
 */

/** Vite 工作台 .env：VITE_DEV_AUTH_BYPASS=1 时不走飞书 OAuth（须重启 dev server） */
export function isViteDevAuthBypassEnabled(): boolean {
  try {
    return (
      typeof import.meta !== 'undefined'
      && String((import.meta as unknown as { env?: Record<string, string> }).env?.VITE_DEV_AUTH_BYPASS || '')
        === '1'
    )
  } catch {
    return false
  }
}

export const DEV_BYPASS_LOGOUT_SESSION_KEY = 'cnkis_dev_bypass_logged_out'

export function isDevBypassLogoutSession(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return sessionStorage.getItem(DEV_BYPASS_LOGOUT_SESSION_KEY) === '1'
  } catch {
    return false
  }
}

export function clearDevBypassLogoutSession(): void {
  try {
    sessionStorage.removeItem(DEV_BYPASS_LOGOUT_SESSION_KEY)
  } catch {
    /* ignore */
  }
}

/** 地址栏带此参数时清除「旁路已退出」标记（同标签页刷新不会清 sessionStorage，避免误以为刷新能恢复） */
export const DEV_BYPASS_RESUME_QUERY = 'cnkis_dev_bypass_resume'

export function consumeDevBypassResumeFromUrl(): boolean {
  if (typeof window === 'undefined') return false
  try {
    const pageSearch = new URLSearchParams(window.location.search)
    if (pageSearch.get(DEV_BYPASS_RESUME_QUERY) === '1') {
      pageSearch.delete(DEV_BYPASS_RESUME_QUERY)
      const qs = pageSearch.toString()
      const nextSearch = qs ? `?${qs}` : ''
      window.history.replaceState(
        {},
        '',
        `${window.location.pathname}${nextSearch}${window.location.hash}`,
      )
      return true
    }
    const hash = window.location.hash || ''
    const qIdx = hash.indexOf('?')
    if (qIdx < 0) return false
    const path = hash.slice(0, qIdx)
    const hParams = new URLSearchParams(hash.slice(qIdx + 1))
    if (hParams.get(DEV_BYPASS_RESUME_QUERY) !== '1') return false
    hParams.delete(DEV_BYPASS_RESUME_QUERY)
    const tail = hParams.toString()
    const nextHash = tail ? `${path}?${tail}` : path
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}${window.location.search}${nextHash}`,
    )
    return true
  } catch {
    return false
  }
}
